import { Box, Flex, Text } from '@chakra-ui/react';

interface ContentAuthorProps {
  name?: string;
  createdAt?: string;
}

function getInitials(name?: string): string {
  if (!name) return '?';
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0][0].toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

function formatCreatedDate(value?: string): string {
  if (!value) return '';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
}

function ContentAuthor({ name, createdAt }: ContentAuthorProps) {
  const createdDate = formatCreatedDate(createdAt);
  if (!name && !createdDate) return null;

  return (
    <Flex align='center' gap={3} mb={6} className='no-print'>
      <Flex
        w='40px'
        h='40px'
        borderRadius='full'
        bg='red.500'
        color='white'
        align='center'
        justify='center'
        fontSize='sm'
        fontWeight='semibold'
        flexShrink={0}
      >
        {getInitials(name)}
      </Flex>
      <Box>
        {name && (
          <Text fontSize='sm' fontWeight='medium'>
            {name}
          </Text>
        )}
        {createdDate && (
          <Text fontSize='xs' color='gray.500'>
            Created {createdDate}
          </Text>
        )}
      </Box>
    </Flex>
  );
}

export default ContentAuthor;
